import React, { createContext, useContext, useEffect, useState } from 'react';

const ChartsContext = createContext(null);

const STORAGE_KEY = 'canales_charts_hidden';

/**
 * Iter 78 — Global "ocultar gráficas" toggle.
 *
 * Strategy: when `hidden=true` we add `charts-hidden` to <body>. The CSS in
 * App.css then hides every Recharts container + cards marked as chart cards.
 * This keeps the toggle dirt-cheap (no need to edit each dashboard).
 */
export function ChartsVisibilityProvider({ children }) {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    try {
      setHidden(localStorage.getItem(STORAGE_KEY) === '1');
    } catch { /* ignore */ }
  }, []);

  useEffect(() => {
    if (hidden) document.body.classList.add('charts-hidden');
    else document.body.classList.remove('charts-hidden');
  }, [hidden]);

  const toggle = () => {
    setHidden((v) => {
      const next = !v;
      try { localStorage.setItem(STORAGE_KEY, next ? '1' : '0'); } catch { /* ignore */ }
      return next;
    });
  };

  return (
    <ChartsContext.Provider value={{ hidden, toggle }}>
      {children}
    </ChartsContext.Provider>
  );
}

export function useChartsVisibility() {
  const ctx = useContext(ChartsContext);
  if (!ctx) return { hidden: false, toggle: () => {} };
  return ctx;
}
